import React, { ReactNode } from "react";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

interface CommonModalProps {
  children?: ReactNode;
}
const Navbar: React.FC<CommonModalProps> = ({ children }) => {
  return (
    <div className="topbar">
      <label htmlFor="humberIcon">
        <div className="closemenu openmenu">
          <MenuOpenIcon />
        </div>
      </label>
      <div className="person_icon">{children}</div>
    </div>
  );
};

export default Navbar;
